import { CalendarTaskState, DatabaseRecordType } from "../enums";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface ICalendarTaskItem {
    id: string;
    parentId: string; //nullable
    companyId: string;
    recordId: string; //nullable
    startDate: number;
    endDate: number; //nullable
    allDay: boolean;
    title: string;
    state: CalendarTaskState;
    isPrivate: boolean;
    databaseRecordType: DatabaseRecordType; //nullable
    locationText: string;
    description: string;
    categoryId: string;
    categoryCode: string;
    categoryColor: string;
    remainder: number;
    createUser: IModifyUser;
    modifyUser: IModifyUser;

    stateStr: string;
}

export class CalendarTaskItem implements ICalendarTaskItem {
    id: string;
    parentId: string;
    companyId: string;
    recordId: string;
    startDate: number;
    endDate: number;
    allDay: boolean;
    title: string;
    state: CalendarTaskState;
    isPrivate: boolean;
    databaseRecordType: DatabaseRecordType;
    locationText: string;
    description: string;
    categoryId: string;
    categoryCode: string;
    categoryColor: string;
    remainder: number;
    createUser: IModifyUser;
    modifyUser: IModifyUser;

    stateStr: string;

    constructor();
    constructor(obj: ICalendarTaskItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.parentId = obj?.parentId;
        this.companyId = obj && obj.companyId || "";
        this.recordId = obj?.recordId;
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj?.endDate;
        this.allDay = obj && obj.allDay || false;
        this.title = obj && obj.title || "";
        this.state = obj && obj.state || CalendarTaskState.NotStarted;
        this.isPrivate = obj && obj.isPrivate || false;
        this.databaseRecordType = obj?.databaseRecordType;
        this.locationText = obj && obj.locationText || "";
        this.description = obj && obj.description || "";
        this.categoryId = obj && obj.categoryId || "";
        this.categoryCode = obj && obj.categoryCode || "";
        this.categoryColor = obj && obj.categoryColor || "";
        this.remainder = obj && obj.remainder || 0;
        this.createUser = new ModifyUser(obj ? obj.createUser : null);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}